import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import { GetUnlinkedInstancesDocument } from "@hydrologiq/gql-experience/graphql"
import { UnlinkedInstance } from "./useDataConnections"

export interface UseUnlinkedInstancesReturn {
  unlinkedInstances: UnlinkedInstance[]
  loadingUnlinked: boolean
}

export function useUnlinkedInstances(connectorId: string): UseUnlinkedInstancesReturn {
  const { data, loading } = useQueryWithEndpoint(
    GetUnlinkedInstancesDocument,
    {
      variables: { monitorId: connectorId },
      skip: !connectorId,
    },
    "primary",
  )

  const unlinkedInstances = (data?.getUnlinkedInstances ?? []) as UnlinkedInstance[]

  return {
    unlinkedInstances,
    loadingUnlinked: loading,
  }
}
